import * as THREE from "three";

export const items = [
  // Untextured models (letters/text) - low mass, movable
  {
    modelPath: "/letters_3D/V.glb",
    position: new THREE.Vector3(-2, 0, 4),
    rotation: new THREE.Euler(0, 0, 0),
    scale: new THREE.Vector3(2.5, 2.5, 2.5),
    type: "untextured",
    enableCollision: true,
    enablePhysics: true,
    mass: 2,
    friction: 0.6,
    physicsShape: "box",
    interactionCallback: null, // Will be set during loading
  },
  {
    modelPath: "/letters_3D/E.glb",
    position: new THREE.Vector3(-1, 0, 4),
    rotation: new THREE.Euler(0, 0, 0),
    scale: new THREE.Vector3(2.5, 2.5, 2.5),
    type: "untextured",
    enableCollision: true,
    enablePhysics: true,
    mass: 2,
    friction: 0.6,
    physicsShape: "box",
    interactionCallback: null, // Will be set during loading
  },
  {
    modelPath: "/letters_3D/N.glb",
    position: new THREE.Vector3(0, 0, 4),
    rotation: new THREE.Euler(0, 0, 0),
    scale: new THREE.Vector3(2.5, 2.5, 2.5),
    type: "untextured",
    enableCollision: true,
    enablePhysics: true,
    mass: 2,
    friction: 0.6,
    physicsShape: "box",
    interactionCallback: null, // Will be set during loading
  },
  {
    modelPath: "/letters_3D/N.glb",
    position: new THREE.Vector3(1.1, 0, 4),
    rotation: new THREE.Euler(0, 0, 0),
    scale: new THREE.Vector3(2.5, 2.5, 2.5),
    type: "untextured",
    enableCollision: true,
    enablePhysics: true,
    mass: 2,
    friction: 0.6,
    physicsShape: "box",
    interactionCallback: null, // Will be set during loading
  },
  {
    modelPath: "/letters_3D/A.glb",
    position: new THREE.Vector3(2.3, 0, 4),
    rotation: new THREE.Euler(0, 0, 0),
    scale: new THREE.Vector3(2.5, 2.5, 2.5),
    type: "untextured",
    enableCollision: true,
    enablePhysics: true,
    mass: 2,
    friction: 0.6,
    physicsShape: "box",
    interactionCallback: null, // Will be set during loading
  },
  {
    modelPath: "/letters_3D/VENNA_TEXT.glb",
    position: new THREE.Vector3(-20, 7, -15),
    rotation: new THREE.Euler((3 * Math.PI) / 2, 0, 0),
    scale: new THREE.Vector3(3, 3, 3),
    type: "untextured",
    enableCollision: true,
    enablePhysics: true,
    physicsShape: "box",
    mass: 200,
    interactionCallback: null, // Will be set during loading
  },
  // Signposts - very high mass, effectively immovable
  {
    modelPath: "/signpost_compressed.glb",
    screenshotPath: "/project_ss/header.png",
    position: new THREE.Vector3(-10, 0, 5),
    rotation: new THREE.Euler(0, (3 * Math.PI) / 2, 0),
    scale: new THREE.Vector3(1.5, 1.5, 1.5),
    type: "signpost",
    enableCollision: true,
    enablePhysics: true,
    mass: 10000, // Very high mass = effectively immovable
    friction: 0.8,
    physicsShape: "box",
    // Signpost-specific properties
    // zoneWidth: 4,
    // zoneDepth: 4,
    // url: 'https://fibonacci-spiral-detecti-bf743.web.app/',
    // name: 'Hi!'
  },

  // WASD
  {
    modelPath: "/letters_3D/W.glb",
    position: new THREE.Vector3(-3.7, 0, 11.5),
    rotation: new THREE.Euler(0, 0, 0),
    scale: new THREE.Vector3(1.3, 1.3, 1.3),
    type: "untextured",
    enableCollision: true,
    enablePhysics: true,
    physicsShape: "sphere",
    mass: 0.3,
    interactionCallback: null, // Will be set during loading
  },
  {
    modelPath: "/letters_3D/A.glb",
    position: new THREE.Vector3(-4.7, 1, 12.5),
    rotation: new THREE.Euler((3 / 2) * Math.PI, 0, 0),
    scale: new THREE.Vector3(1.3, 1.3, 1.3),
    type: "untextured",
    enableCollision: true,
    enablePhysics: true,
    physicsShape: "sphere",
    mass: 0.3,
    interactionCallback: null, // Will be set during loading
  },
  {
    modelPath: "/letters_3D/S.glb",
    position: new THREE.Vector3(-3.7, 0, 12.5),
    rotation: new THREE.Euler(0, 0, 0),
    scale: new THREE.Vector3(1.3, 1.3, 1.3),
    type: "untextured",
    enableCollision: true,
    enablePhysics: true,
    physicsShape: "sphere",
    mass: 0.3,
    interactionCallback: null, // Will be set during loading
  },
  {
    modelPath: "/letters_3D/D.glb",
    position: new THREE.Vector3(-2.7, 0, 12.5),
    rotation: new THREE.Euler(0, 0, 0),
    scale: new THREE.Vector3(1.3, 1.3, 1.3),
    type: "untextured",
    enableCollision: true,
    enablePhysics: true,
    physicsShape: "sphere",
    mass: 0.3,
    interactionCallback: null, // Will be set during loading
  },
  {
    modelPath: "/letters_3D/R.glb",
    position: new THREE.Vector3(-2.7, 0, 14.1),
    rotation: new THREE.Euler(0, 0, 0),
    scale: new THREE.Vector3(1.3, 1.3, 1.3),
    type: "untextured",
    enableCollision: true,
    enablePhysics: true,
    physicsShape: "sphere",
    mass: 0.3,
    interactionCallback: null, // Will be set during loading
  },
  {
    modelPath: "/letters_3D/G.glb",
    position: new THREE.Vector3(-3.1, 0, 16.2),
    rotation: new THREE.Euler(0, 0, 0),
    scale: new THREE.Vector3(1.3, 1.3, 1.3),
    type: "untextured",
    enableCollision: true,
    enablePhysics: true,
    physicsShape: "sphere",
    mass: 0.3,
    interactionCallback: null, // Will be set during loading
  },

  //beveled_cube
  {
    modelPath: "/beveled_cube.glb",
    position: new THREE.Vector3(9, 0, 12.5),
    rotation: new THREE.Euler(0, (3 * Math.PI) / 5, 0),
    scale: new THREE.Vector3(4, 4, 4),
    type: "untextured",
    enableCollision: true,
    enablePhysics: true,
    physicsShape: "box",
    mass: 0.3,
    interactionCallback: null, // Will be set during loading
  },
  {
    modelPath: "/beveled_cube_yellow.glb",
    position: new THREE.Vector3(8.8, 5, 12.5),
    rotation: new THREE.Euler(0, (7 * Math.PI) / 5, 0),
    scale: new THREE.Vector3(3.6, 3.6, 3.6),
    type: "untextured",
    enableCollision: true,
    enablePhysics: true,
    physicsShape: "box",
    mass: 0.3,
    interactionCallback: null, // Will be set during loading
  },
  {
    modelPath: "/beveled_cube_pink.glb",
    position: new THREE.Vector3(-9, 0.1, 10.5),
    rotation: new THREE.Euler(0, (7 * Math.PI) / 5, 0),
    scale: new THREE.Vector3(3.6, 3.6, 3.6),
    type: "untextured",
    enableCollision: true,
    enablePhysics: true,
    physicsShape: "box",
    mass: 0.3,
    interactionCallback: null, // Will be set during loading
  },
  {
    modelPath: "/beveled_cube.glb",
    position: new THREE.Vector3(-5, 0.11, 6),
    rotation: new THREE.Euler(0, (7 * Math.PI) / 5, 0),
    scale: new THREE.Vector3(1, 1, 1),
    type: "untextured",
    enableCollision: true,
    enablePhysics: true,
    physicsShape: "box",
    mass: 0.3,
    interactionCallback: null, // Will be set during sloading
  },
  {
    modelPath: "/triangle.glb",
    position: new THREE.Vector3(-8, 2.11, 14),
    rotation: new THREE.Euler(0, (7 * Math.PI) / 5, 0),
    scale: new THREE.Vector3(1, 1, 1),
    type: "untextured",
    enableCollision: true,
    enablePhysics: true,
    physicsShape: "mesh",
    mass: 2.8,
    friction: 0.001,
    interactionCallback: null, // Will be set during sloading
  },
  {
    modelPath: "/triangle.glb",
    position: new THREE.Vector3(-11, 2.11, -34),
    rotation: new THREE.Euler(0, (-2 * Math.PI) / 5, 0),
    scale: new THREE.Vector3(2, 3, 3.5),
    type: "untextured",
    enableCollision: true,
    enablePhysics: true,
    physicsShape: "mesh",
    mass: 30,
    friction: 0.001,
    interactionCallback: null, // Will be set during sloading
  },
  {
    modelPath: "/triangle.glb",
    position: new THREE.Vector3(15, 2.11, 10),
    rotation: new THREE.Euler((-7 * Math.PI) / 5, (-7 * Math.PI) / 5, 0),
    scale: new THREE.Vector3(1, 1, 1),
    type: "untextured",
    enableCollision: true,
    enablePhysics: true,
    physicsShape: "mesh",
    mass: 10,
    friction: 0.01,
    interactionCallback: null, // Will be set during sloading
  },

  //foundation_acrylic_stand
  {
    modelPath: "/foundation_chibi_acrylic_stand.glb",
    position: new THREE.Vector3(0, 5, -12.5),
    rotation: new THREE.Euler(0, 0, 0),
    scale: new THREE.Vector3(3, 3, 3),
    type: "untextured",
    enableCollision: true,
    enablePhysics: true,
    physicsShape: "box",
    mass: 300,
    interactionCallback: null, // Will be set during loading
  },
  // trees
  {
    modelPath: "/Tree.glb",
    position: new THREE.Vector3(-5, 0.1, 3),
    rotation: new THREE.Euler(0, 0, 0),
    scale: new THREE.Vector3(1, 1, 1),
    type: "untextured",
    enableCollision: true,
    enablePhysics: true,
    physicsShape: "box",
    mass: 300,
    interactionCallback: null, // Will be set during loading
  },
  {
    modelPath: "/Tree.glb",
    position: new THREE.Vector3(5, 0.1, 3),
    rotation: new THREE.Euler(0, (1 * Math.PI) / 2, 0),
    scale: new THREE.Vector3(1, 1, 1),
    type: "untextured",
    enableCollision: true,
    enablePhysics: true,
    physicsShape: "box",
    mass: 300,
    interactionCallback: null, // Will be set during loading
  },
  {
    modelPath: "/Tree.glb",
    position: new THREE.Vector3(4, 0.1, -1),
    rotation: new THREE.Euler(0, (2 * Math.PI) / 2, 0),
    scale: new THREE.Vector3(0.9, 0.9, 0.9),
    type: "untextured",
    enableCollision: true,
    enablePhysics: true,
    mass: 300,
  },
  {
    modelPath: "/Tree.glb",
    position: new THREE.Vector3(-4, 0.1, 0),
    rotation: new THREE.Euler(0, (3 * Math.PI) / 2, 0),
    scale: new THREE.Vector3(0.9, 0.9, 0.9),
    type: "untextured",
    enableCollision: true,
    enablePhysics: true,
    physicsShape: "box",
    mass: 300,
    interactionCallback: null, // Will be set during loading
  },
  //stones
  {
    modelPath: "/Stone_1.glb",
    position: new THREE.Vector3(4, 0.1, 4),
    rotation: new THREE.Euler(0, (3 * Math.PI) / 2, 0),
    scale: new THREE.Vector3(0.5, 0.5, 0.5),
    type: "untextured",
    enableCollision: true,
    enablePhysics: true,
    physicsShape: "box",
    mass: 30,
    interactionCallback: null, // Will be set during loading
  },
  {
    modelPath: "/Stone_2.glb",
    position: new THREE.Vector3(4.3, 0.1, 5),
    rotation: new THREE.Euler(0, (7 * Math.PI) / 2, 0),
    scale: new THREE.Vector3(0.3, 0.3, 0.3),
    type: "untextured",
    enableCollision: true,
    enablePhysics: true,
    physicsShape: "box",
    mass: 30,
    interactionCallback: null, // Will be set during loading
  },
  {
    modelPath: "/Stone_2.glb",
    position: new THREE.Vector3(-4.3, 0.1, 4),
    rotation: new THREE.Euler(0, (9 * Math.PI) / 2, 0),
    scale: new THREE.Vector3(0.3, 0.3, 0.3),
    type: "untextured",
    enableCollision: true,
    enablePhysics: true,
    physicsShape: "box",
    mass: 30,
    interactionCallback: null, // Will be set during loading
  },
  //tiles_mainpath
  {
    modelPath: "/Tile.glb",
    position: new THREE.Vector3(0.1, 0.1, 2),
    rotation: new THREE.Euler(0, 0, 0),
    scale: new THREE.Vector3(0.7, 0.7, 0.7),
    type: "untextured",
    physicsShape: "box",
    mass: 30,
  },
  {
    modelPath: "/Tile.glb",
    position: new THREE.Vector3(-0.3, 0.1, 0),
    rotation: new THREE.Euler(0, 0, 0),
    scale: new THREE.Vector3(0.7, 0.7, 0.7),
    type: "untextured",
    physicsShape: "box",
    mass: 30,
  },
  {
    modelPath: "/Tile.glb",
    position: new THREE.Vector3(0.3, 0.1, -2),
    rotation: new THREE.Euler(0, 0, 0),
    scale: new THREE.Vector3(0.7, 0.7, 0.7),
    type: "untextured",
    physicsShape: "box",
    mass: 30,
  },
  {
    modelPath: "/Tile_cracked_1.glb",
    position: new THREE.Vector3(-0.1, 0.1, -4),
    rotation: new THREE.Euler(0, 0, 0),
    scale: new THREE.Vector3(0.7, 0.7, 0.7),
    type: "untextured",
    physicsShape: "box",
    mass: 30,
  },
  {
    modelPath: "/Tile.glb",
    position: new THREE.Vector3(0.4, 0.1, -6),
    rotation: new THREE.Euler(0, 0, 0),
    scale: new THREE.Vector3(0.7, 0.7, 0.7),
    type: "untextured",
    physicsShape: "box",
    mass: 30,
  },
  //tiles_gallery
  {
    modelPath: "/Tile.glb",
    position: new THREE.Vector3(8, 0.1, -13),
    rotation: new THREE.Euler(0, 0, 0),
    scale: new THREE.Vector3(0.7, 0.7, 0.7),
    type: "untextured",
    physicsShape: "box",
    mass: 30,
  },
  {
    modelPath: "/Tile.glb",
    position: new THREE.Vector3(10, 0.1, -13.5),
    rotation: new THREE.Euler(0, 0.1, 0),
    scale: new THREE.Vector3(0.7, 0.7, 0.7),
    type: "untextured",
    physicsShape: "box",
    mass: 30,
  },
  {
    modelPath: "/Tile.glb",
    position: new THREE.Vector3(12, 0.1, -12.7),
    rotation: new THREE.Euler(0, 0, 0),
    scale: new THREE.Vector3(0.7, 0.7, 0.7),
    type: "untextured",
    physicsShape: "box",
    mass: 30,
  },
  {
    modelPath: "/Tile_cracked_1.glb",
    position: new THREE.Vector3(14, 0.1, -13.1),
    rotation: new THREE.Euler(0, 0, 0),
    scale: new THREE.Vector3(0.7, 0.7, 0.7),
    type: "untextured",
    physicsShape: "box",
    mass: 30,
  },
  {
    modelPath: "/Tile_cracked_1.glb",
    position: new THREE.Vector3(16, 0.1, -13.1),
    rotation: new THREE.Euler(0, (0.91 / 2) * Math.PI, 0),
    scale: new THREE.Vector3(0.7, 0.7, 0.7),
    type: "untextured",
    physicsShape: "box",
    mass: 30,
  },
  //Stones_gallery
  {
    modelPath: "/Stone_2.glb",
    position: new THREE.Vector3(16, 0.1, -14.3),
    rotation: new THREE.Euler(0, (9 * Math.PI) / 2, 0),
    scale: new THREE.Vector3(0.3, 0.3, 0.3),
    type: "untextured",
    enableCollision: true,
    enablePhysics: true,
    physicsShape: "box",
    mass: 30,
    interactionCallback: null, // Will be set during loading
  },
  {
    modelPath: "/Stone_1.glb",
    position: new THREE.Vector3(7, 0.1, -14.3),
    rotation: new THREE.Euler(0, (9 * Math.PI) / 2, 0),
    scale: new THREE.Vector3(0.3, 0.3, 0.3),
    type: "untextured",
    enableCollision: true,
    enablePhysics: true,
    physicsShape: "box",
    mass: 30,
    interactionCallback: null, // Will be set during loading
  },

  //Panel_gallery
  {
    modelPath: "/Panel_gallery.glb",
    position: new THREE.Vector3(3, 3, -7),
    rotation: new THREE.Euler(0, (0.8 / 2) * Math.PI, (0.8 / 2) * Math.PI),
    scale: new THREE.Vector3(1.2, 1.2, 1.2),
    type: "untextured",
    physicsShape: "box",
    enableCollision: true,
    enablePhysics: true,
    mass: 30,
  },
  {
    modelPath: "/Panel_creator.glb",
    position: new THREE.Vector3(-3, 3, -7),
    rotation: new THREE.Euler(0, (-0.8 / 2) * Math.PI, (-0.8 / 2) * Math.PI),
    scale: new THREE.Vector3(1.2, 1.2, 1.2),
    type: "untextured",
    physicsShape: "box",
    enableCollision: true,
    enablePhysics: true,
    mass: 30,
  },
  //directions
  {
    modelPath: "/left.glb",
    position: new THREE.Vector3(-3, 4, -6),
    rotation: new THREE.Euler(0, (-0.9 / 2) * Math.PI, (-0.8 / 2) * Math.PI),
    scale: new THREE.Vector3(1.8, 1.8, 1.8),
    type: "untextured",
    physicsShape: "box",
    enableCollision: true,
    enablePhysics: true,
    mass: 59,
  },
  //directions
  {
    modelPath: "/left.glb",
    position: new THREE.Vector3(3, 4, -6),
    rotation: new THREE.Euler(0, (0.9 / 2) * Math.PI, (0.8 / 2) * Math.PI),
    scale: new THREE.Vector3(1.8, 1.8, 1.8),
    type: "untextured",
    physicsShape: "box",
    enableCollision: true,
    enablePhysics: true,
    mass: 59,
  },
];
